const LoadingSpinner: React.FC<{ size?: string }> = ({ size = '3rem' }) => (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
        <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: size, height: size }}
        >
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

export default LoadingSpinner;